export default "__VITE_ASSET__DGXSwXg$__"